import { useTheme } from 'styled-components';

import { Paragraph } from '@/core/components/Typography';

import { MessageBubble, MessageGroup, MessageMeta, MessageRow } from './ChatContent.styles';
import { MarkdownText } from './MarkdownText';
import { UserMessageProps } from './UserMessage.types';

export const UserMessage = ({ text, timestamp }: UserMessageProps) => {
  const { colors } = useTheme();

  return (
    <MessageGroup $isUser>
      <MessageRow $isUser>
        <MessageBubble $isUser>
          <MarkdownText
            text={text}
            paragraphType="tiny"
          />
        </MessageBubble>
      </MessageRow>
      {timestamp && (
        <MessageMeta $isUser>
          <Paragraph
            type="tiny"
            color={colors.secondaryText}
          >
            {timestamp}
          </Paragraph>
        </MessageMeta>
      )}
    </MessageGroup>
  );
};
